(function ($) {
  $(window).on('load', function () {
    initPhotoSwipeFromDOM('.gallery');
    var resizeId;

    function doneResizing() {
      $('.gallery.grid-h').GridHorizontal({
        item: '.item',
        minWidth: 168,
        maxRowHeight: 225,
        gutter: 20,
      });
    }
    doneResizing();
    $(window).resize(function () {
      clearTimeout(resizeId);
      resizeId = setTimeout(doneResizing, 500);
    });
  });
})($);